{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TransactionData.schema.json",
  "title": "TransactionData",
  "type": "object",
  "properties": {
    "type": {
      "type": "string"
    },
    "credential_ids": {
      "type": "array",
      "items": {
        "type": "string"
      }
    }
  },
  "required": [
    "type",
    "credential_ids"
  ],
  "additionalProperties": false
}